import { AdapterFactory } from '../AdapterFactory';

export const attachmentService = AdapterFactory.getAttachmentAdapter();
